<div class="page">
  <app-page-header  page-title="ddts.checklistPage.pageTitle">
  </app-page-header>
  <div class="page-content">
    <mat-card class="custom-card mt-4">
      <div class="row">
        <div class="col-6">
          <mat-card-title>{{ 'ddts.checklistPage.documentsTab.title' | translate }}
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </div>
        <div class="col-6">

        </div>
      </div>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12">
              <app-card-spinner [visible]="documentArchiveIsLoading" type="zero"></app-card-spinner>
              <ng-container>
                <table class="table table-borderless table-striped" matSort (matSortChange)="sortData($event)" matSortDisableClear id="excel-table">
                  <thead>
                    <th>#</th>
                    <th class="clickable" mat-sort-header="ddtCode">{{ 'ddts.checklistPage.documentsTab.ddt' | translate }}</th>
                    <th class="clickable" mat-sort-header="file">{{ 'ddts.checklistPage.documentsTab.file' | translate }}</th>
                    <th class="clickable" mat-sort-header="docs">{{ 'ddts.checklistPage.documentsTab.docs' | translate }}</th>
                    <th>{{ 'common.cta.actions' | translate }}</th>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of sortedData; let i = index">
                      <th style="width: 3%">{{ i + 1 }}</th>
                      <td style="width: 25%">{{ item.ddtCode }}</td>
                      <td style="width: 30%">{{ item.file }}</td>
                      <td style="width: 30%">{{ item.docs }}</td>
                      <td style="width: 12%">
                        <button mat-icon-button matTooltip="{{ 'ddts.checklistPage.documentsTab.viewDetail' | translate }}"
                        routerLink="/{{ lang}}/app/ddts/checklist-detail/{{item.ddtId}}">
                          <mat-icon fontSet="fal" fontIcon="fa-search-plus" class="icon-action">
                          </mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </div> <!-- /.col -->
          </div> <!-- /.row -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->